import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './units/auth/AuthProvider';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { GlobalProvider } from './units/global/GlobalProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <AuthProvider>
            <GlobalProvider>
                <HashRouter>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <App />
                    </MuiPickersUtilsProvider>
                </HashRouter>
            </GlobalProvider>
        </AuthProvider>
    </React.StrictMode>,
);
